<template>
  <component :is="this.dynamicComponent" />
</template>


<script lang="ts">
import { defineAsyncComponent } from 'vue';
import { Component, Prop, Vue } from 'vue-facing-decorator';

@Component({
  emits: [],
  components: {

  },
})
export default class TickIcon extends Vue {
  @Prop() private name!: string;

  private get dynamicComponent() {
    // store name in const to allow reactivity
    const name = this.name;
    return defineAsyncComponent(() => import(`@/components/icons/icon-${name}.vue`));
  }

}
</script>